module.exports = __webpack_public_path__ + "img/bb_g3_eyes-05.9b057c98.svg";